import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoAddPlus = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>AddPlus</title>
    <path d="M16 7.845v18.286M25.142 16.988H6.857" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default SvgIcoAddPlus;
